/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Integrations_Org_Managed_HintInputs */



/**
* | output |
* | --- |
* | "Set up by your organisation — no connection needed." |
*
* @param {My_Integrations_Org_Managed_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const my_integrations_org_managed_hint = /** @type {((inputs?: My_Integrations_Org_Managed_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Integrations_Org_Managed_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Von Ihrer Organisation eingerichtet — keine Verbindung nötig.")
	return /** @type {LocalizedString} */ ("Set up by your organisation — no connection needed.")
});